import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { DownloadSimple, FileText, Eye, EyeSlash, EnvelopeSimple } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import {
  downloadPdf, downloadDocx, togglePreview, resendReportEmail, getPreviewMode,
} from './reportActionHandlers';

const PreviewToggleButton = ({ mode, rowIndex, busy, onClick }) => {
  if (mode === 'real_paid') return null;
  const isUnlocked = mode === 'unlocked';
  return (
    <Button
      size="sm" variant="outline" onClick={onClick} disabled={busy}
      data-testid={`preview-toggle-button-${rowIndex}`}
      className={isUnlocked
        ? 'border-amber-300 text-amber-700 hover:bg-amber-50'
        : 'border-teal-300 text-teal-700 hover:bg-teal-50'}
      title={isUnlocked ? 'Re-lock this preview (does not affect real payments)' : 'Unlock this assessment for QA review'}
    >
      {isUnlocked
        ? <><EyeSlash size={16} className="mr-1" />Lock Preview</>
        : <><Eye size={16} className="mr-1" />Preview as Paid</>}
    </Button>
  );
};

const ResendEmailButton = ({ rowIndex, busy, onClick }) => (
  <Button
    size="sm" variant="outline" onClick={onClick} disabled={busy}
    data-testid={`resend-email-button-${rowIndex}`}
    className="border-slate-300 text-slate-700 hover:bg-slate-50"
    title="Resend the Professional Report PDF to the customer email"
  >
    <EnvelopeSimple size={16} className="mr-1" />
    Resend Email
  </Button>
);

const ReportActions = ({ assessmentId, rowIndex, paymentStatus, previewUnlock, onChanged }) => {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const mode = getPreviewMode({ paymentStatus, previewUnlock });

  return (
    <div className="flex gap-2 flex-wrap">
      <Button size="sm" variant="outline" onClick={() => navigate(`/results/${assessmentId}`)}
              data-testid={`view-results-button-${rowIndex}`}>
        <FileText size={16} className="mr-1" />View
      </Button>
      <Button
        size="sm"
        variant="outline"
        onClick={() => downloadPdf(assessmentId)}
        data-testid={`download-pdf-button-${rowIndex}`}
        title="Generate and download Professional Diagnostic Report PDF"
        className="border-teal-300 text-teal-700 hover:bg-teal-50"
      >
        <DownloadSimple size={16} className="mr-1" />
        Professional Report
      </Button>
      <Button
        size="sm"
        variant="outline"
        onClick={() => downloadDocx(assessmentId)}
        data-testid={`download-docx-button-${rowIndex}`}
        title="Generate and download editable DOCX (Microsoft Word / Google Docs)"
        className="border-indigo-300 text-indigo-700 hover:bg-indigo-50"
      >
        <DownloadSimple size={16} className="mr-1" />
        Editable DOCX
      </Button>
      <PreviewToggleButton mode={mode} rowIndex={rowIndex} busy={busy}
        onClick={() => togglePreview(assessmentId, mode, onChanged, setBusy)} />
      {paymentStatus === 'paid' && (
        <ResendEmailButton rowIndex={rowIndex} busy={busy}
          onClick={() => resendReportEmail(assessmentId, onChanged, setBusy)} />
      )}
    </div>
  );
};

export default ReportActions;
